module.exports = __webpack_public_path__ + "img/CANAM3.44824def.png";